
import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <g id="Group_1814" data-name="Group 1814" transform="translate(-844.5 -4805)">
                <g id="Ellipse_125" data-name="Ellipse 125" transform="translate(844.5 4805)" fill="#fff" stroke="#707070" strokeWidth="1">
                <circle cx="13" cy="13" r="13" stroke="none"/>
                <circle cx="13" cy="13" r="12.5" fill="none"/>
                </g>
                <text id="_" data-name="+" transform="translate(851.5 4824)" fill="#1f1f1f" fontSize="18" fontFamily="Helvetica"><tspan x="0" y="0">+</tspan></text>
            </g>
        </svg>
    );
}